import React from 'react';
import { Typography } from '@mui/material';

import { isUpgradeItem } from './cartLineKinds';
import {
  getBasePrice,
  getDiscountedPrice,
  getEffectivePrice,
} from './cartPricing';
import { isOrderScopeDiscount } from './cartTotals';

export interface CartLinePriceDisplayProps {
  item: any;
  allHostApp: any;
  serialRowsContainAllHostApps: boolean;
}

export function CartLinePriceDisplay({
  item,
  allHostApp,
  serialRowsContainAllHostApps,
}: CartLinePriceDisplayProps) {
  const base = getBasePrice(item.productId, item.hostApplication);
  const saleAware = getEffectivePrice(item.productId, item.hostApplication);
  // Order-scope discounts apply once to the order total — no per-line price
  // change or strike (the savings show on the cart SUMMARY only).
  const hasLineDiscount =
    !!item.discountId && !isOrderScopeDiscount(item.discountId);

  const isAllHostsUpgrade =
    isUpgradeItem(item) &&
    serialRowsContainAllHostApps &&
    typeof allHostApp?.priceOverride === 'number';

  const allHostsFull = isAllHostsUpgrade
    ? base + allHostApp.priceOverride
    : base;

  let strikePrice: number | null = null;
  let displayPrice = saleAware;

  if (isAllHostsUpgrade) {
    if (hasLineDiscount) {
      strikePrice = allHostsFull;

      if (item.discountId.amountUnits === 'percent') {
        displayPrice = allHostsFull * (1 - item.discountId.amount / 100);
      } else if (item.discountId.amountUnits === 'dollars') {
        displayPrice = allHostsFull - item.discountId.amount;
      } else {
        displayPrice = allHostsFull;
      }
    } else {
      strikePrice = saleAware < base ? base : null;
      displayPrice = saleAware;
    }
  } else {
    displayPrice = hasLineDiscount
      ? getDiscountedPrice(
          item.productId,
          item.discountId,
          item.hostApplication,
        )
      : saleAware;

    // Strike list when sale or discount lowers the unit vs list.
    const showStrike = displayPrice < base;

    strikePrice = showStrike ? base : null;
  }

  displayPrice = Math.max(
    0,
    Math.min(strikePrice ?? displayPrice, displayPrice),
  );

  return (
    <Typography
      sx={{
        color: '#08c',
        mb:
          isUpgradeItem(item) &&
          serialRowsContainAllHostApps &&
          allHostApp?.priceOverride
            ? 0
            : 1,
      }}
    >
      {strikePrice != null && displayPrice < strikePrice && (
        <span
          style={{
            textDecoration: 'line-through',
            opacity: 0.6,
            marginRight: '6px',
          }}
        >
          ${strikePrice.toFixed(2)}
        </span>
      )}
      ${displayPrice.toFixed(2)}
    </Typography>
  );
}
